import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Checkout from "../../../../Diathrive/src/containers/Checkout";
import EditAddress from "../../../../Diathrive/src/containers/EditAddress";
import { shopContext } from "../../../../Diathrive/src/contexts/ShopContext";
import RightPannel from "../../components/RightPannel";

const CheckoutFlow = () => {
  const navigate = useNavigate();
  const ShopC = useContext(shopContext);

  return (
    <>
      <Checkout navigation={navigate} />
      <RightPannel
        componentToPassDown={
          <EditAddress
            navigation={navigate}
            route={{
              params:
                typeof ShopC.addOrEditAddress === "boolean"
                  ? {}
                  : { addressData: ShopC.addOrEditAddress },
            }}
            setAddOrEditAddress={ShopC.setAddOrEditAddress}
          />
        }
        open={ShopC.addOrEditAddress}
        onClose={() => ShopC.setAddOrEditAddress(false)}
      />
    </>
  );
};

export default CheckoutFlow;
